import { DateTime } from 'luxon';

type DbFiscalYear = `${number}${number}${number}${number}-${number}${number}${number}${number}`;
type GqlFiscalYear = `${string}To${string}`;

export const parseFiscalYear = (fiscalYear: DbFiscalYear | GqlFiscalYear) => {
  if (fiscalYear.includes('To')) {
    const [start, end] = fiscalYear.split('To') as [string, string];
    return {
      startMonth: DateTime.fromFormat(start, 'MMM', { locale: 'en' }).month,
      endMonth: DateTime.fromFormat(end, 'MMM', { locale: 'en' }).month,
      endDay: DateTime.fromFormat(end, 'MMM', { locale: 'en' }).endOf('month').day,
    };
  }

  const [start, end] = fiscalYear.split('-') as [string, string];
  return {
    startMonth: parseInt(start.slice(0, 2), 10),
    endMonth: parseInt(end.slice(0, 2), 10),
    endDay: parseInt(end.slice(2), 10),
  };
};

export const getStartDateOfMostRecentFiscalYear = (fiscalYear: DbFiscalYear | GqlFiscalYear) => {
  const { startMonth } = parseFiscalYear(fiscalYear);

  const now = DateTime.now().setZone('UTC');
  const currentYear = now.year;
  const currentMonth = now.month;

  const fiscalStartYear = startMonth > currentMonth ? currentYear - 1 : currentYear;

  return DateTime.fromObject(
    {
      year: fiscalStartYear,
      month: startMonth,
      day: 1,
    },
    { zone: 'UTC' },
  );
};

export const getNewEndDateOfFiscalYear = (
  currentFiscalYear: DbFiscalYear | GqlFiscalYear,
  newFiscalYear: DbFiscalYear | GqlFiscalYear,
) => {
  const { endMonth, endDay } = parseFiscalYear(newFiscalYear);

  const startDate = getStartDateOfMostRecentFiscalYear(currentFiscalYear);
  const nextComingEndDay = DateTime.fromObject(
    {
      year: startDate.year,
      month: endMonth,
      day: endDay,
    },
    { zone: 'UTC' },
  );

  const diff = nextComingEndDay.diff(startDate.startOf('month'), 'months').months;

  const baseYear = startDate.year + (diff < 6 ? 1 : 0);

  return DateTime.fromObject(
    {
      year: baseYear,
      month: endMonth,
      day: endDay,
    },
    { zone: 'UTC' },
  );
};
